(() => {
  const seen = new WeakSet();
  const load = async (root) => {
    const url = new URL(root.dataset.hmgRelatedImages, location.origin);
    if (url.origin !== location.origin) return;
    url.search = '';
    url.hash = '';
    url.searchParams.set('section_id', 'hmg-related-category-images');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(url, {credentials: 'same-origin', priority: 'low', signal: controller.signal});
      if (!response.ok) throw new Error('Category images unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const templates = new Map([...doc.querySelectorAll('template[data-hmg-category-image]')].map(node => [node.dataset.hmgCategoryImage, node.content.querySelector('img')]));
      root.querySelectorAll('[data-hmg-category-image]').forEach(slot => {
        const image = templates.get(slot.dataset.hmgCategoryImage);
        if (!image) { slot.hidden = true; return; }
        const copy = image.cloneNode(true);
        copy.addEventListener('error', () => { slot.hidden = true; }, {once: true});
        slot.replaceChildren(copy);
      });
      root.dataset.imagesLoaded = 'true';
    } catch (_) {
      root.querySelectorAll('[data-hmg-category-image]').forEach(slot => { slot.hidden = true; });
    } finally { clearTimeout(timeout); }
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { observer.unobserve(entry.target); load(entry.target); }
    });
  }, {rootMargin: '200px 0px'}) : null;
  const init = (scope) => scope.querySelectorAll('[data-hmg-related-images]').forEach(root => {
    if (seen.has(root)) return;
    seen.add(root);
    if (observer) observer.observe(root);
    else root.querySelectorAll('[data-hmg-category-image]').forEach(slot => { slot.hidden = true; });
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
